<ng-container *ngIf="selectedDistrict">
  {{ selectedDistrict.title }}
</ng-container>
